import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTrial } from "@/hooks/use-trial";
import { TrialUpgradeDialog } from "./TrialUpgradeDialog";
import { Loader2 } from "lucide-react";
import { isNativeIosApp } from "@/lib/platform";

interface TrialGateProps {
  children: React.ReactNode;
}

export function TrialGate({ children }: TrialGateProps) {
  const { isLocked, loading: trialLoading } = useTrial();
  const loading = trialLoading;
  const navigate = useNavigate();
  const location = useLocation();
  const isNativeIos = isNativeIosApp();

  // Allow access to billing page on web even when trial expired.
  const isBillingPage = !isNativeIos && (
    location.pathname === "/app/billing" || location.pathname.startsWith("/app/billing/")
  );

  useEffect(() => {
    if (!isNativeIos && !loading && isLocked && !isBillingPage) {
      navigate("/app/billing", { replace: true });
    }
  }, [isNativeIos, loading, isLocked, isBillingPage, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isLocked && !isBillingPage) {
    return <TrialUpgradeDialog />;
  }

  // Allow access to billing page or if trial is still active
  return <>{children}</>;
}
